import useStore from '../../../../Hooks/useStore';
import DoubleProductsTab from './DoubleProductsTab';
import SingleProductTab from './SingleProductTab';

const ProductTab = () => {
  const [getters, setters] = useStore();
  const {
    ticket: { getTicket },
  } = getters;
  const { pinnedProducts, selectedProducts } = getTicket('form.batch');
  const singleProduct =
    selectedProducts.length <= 1 || pinnedProducts.length === 1;

  return singleProduct ? <SingleProductTab /> : <DoubleProductsTab />;
};

export default ProductTab;
